/*

Raghu 27/10/2022 3225736869 Inputfields and Button Enhancements
Lalitha 10/27/2022 3225736869 night jobs UX changes
Lalitha  11/9/2022 3225736869  Rename Button Clear to Reset
Prakash 11/16/2022 3225736869  Fixed Responsiveness and added class for text fields, buttons..
akhila 11/18/2022 3225736869 added status and createdFsor fields
Guru Prasad 11/22/2022 3225736869 Fixed buttons alignments
Akhila 11/25/2022 3225736869 rename the status field label removed two field nextruntime, lastRunTime.
Suresh Peddavoora 11/28/2022 3225736869 Text Field Responsive Fixes for Desktop Resolution
lalitha 12/06/2022 3225736869 removed job name
lalitha 12/07/2022 3225736869 added Created By field
Akhila 12/08/2022 3225736869 added session storage for search items
kavya9reddy 12/09/2022 3225736869 Added createdDate field
Rohini 12/13/2022 3225736869 Fixed responsiveness for Text field alignments
Rohini 12/16/2022 3225736869 Fixed Buttons Alignment issue in Responsive
Ashraf 12/16/2022 3225736869 fixed role based access
Saikrishna 12/18/2022 3225736869 Fixed jira bugs by QA on night jobs
akhila 12/18/2022 3225736869 fixed Scheduled Status label
dilip 12/21/2022 3225736869 added underscore validation for code
Prakash 12/22/2022 3225736869 Button Alignments Responsiveness.
Rohini 12/30/2022 3225736869 Fixed Button Alignments Responsiveness.
Ashraf 01/02/2022 3225736869 fixed white space validation issue
Dilip 02/09/2023 3225736869 added created for, created by dropdown
Akhila 02/08/2023 3225736869 added client Code field
Sohel 02/09/2023 3225736869 client DropDown value changes
Akhila 02/09/2023 3225736869 Added processing value in dropDown
suresh peddavoora 02/21/2023 3225736869 New UI changes
suresh peddavoora 03/14/2023 3225736869 fixed the responsive in tab
Ravi 04/19/2023 3225736869 modified client code dropDownData data.
Akhila 06/08/2023 3225736869 created date change to date created field and column
Ravi 06/08/2023 3225736869 rearrange search fields
Prakash 22/06/2023 2789725780 fixed alignments issues data picker

*/
import React, {useState, useEffect, useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import {useSelector, useDispatch} from 'react-redux';
import PageLoader from '../../../../../components/PageLoader';
import {SuccessSnackbar, ErrorSnackbar} from '../../../../../components/CustomSnackBar';
import NightJobSearchTable from './NightJobSearchTable';
import * as Yup from 'yup';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {
  getAllReportCreatedForData,
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
} from '../../../../../redux/reducers/ReportMaster';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {getClientCodeDropDownData} from '../../../../../redux/reducers/TriggerGroup';
import {createForOptions, createdByOptions} from '../../../../../util/CreatedByForOptions';
import {ThemeContext} from '../../../../../themes/ThemeProvider';

const NightJobSearch = ({
  setTabValue,
  setValue,
  setSearchData,
  searchData,
  setSelectedRows,
  selectedRows,
  setNightJobCode,
  setIsCopyRowData,
  setJobCode,
  setSelected,
}) => {
  const statuses = [
    {key: 'Scheduled', value: 'Scheduled'},
    {key: 'Processing', value: 'Processing'},
    {key: 'Not scheduled', value: 'Not scheduled'},
  ];
  const StatusOptions = [
    {key: 'Y', value: 'Draft'},
    {key: 'N', value: 'Completed'},
  ];
  const {createdByData, createdForData} = useSelector(
    ({reportMaster}) => reportMaster,
  );

  const {reusableInputStyles} = useContext(ThemeContext);
  const dispatch = useDispatch();
  const classes = reusableInputStyles();
  const searchsessionNightJob = JSON.parse(sessionStorage.getItem('searchNightJob'));
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });
  const initialValues = {
    status: '',
    jobName: '',
    description: '',
    code: '',
    nextRunTime: '',
    lastRunTime: '',
    createdFor: '',
    isDraft: '',
    createdBy: '',
    createdDate: null,
    clientCode: '',
  };
  const [submit, setSubmit] = useState(false);

  const handleSubmit = (data) => {
    setSubmit(true);
    setSearchFlag(true);
    setSearchData(data);
    sessionStorage.setItem('searchNightJob', JSON.stringify(data));
  };
  const [searchFlag, setSearchFlag] = useState(false);
  const {isLoading, successMsg, errorMsg} = useSelector(({addRuleGroup}) => addRuleGroup);

  useEffect(() => {
    dispatch(getClientCodeDropDownData());
    dispatch(getAllReportCreatedForData());
  }, []);

  useEffect(() => {
    dispatch(fetchCreatedByDropDownData('scheduler'));
    dispatch(fetchCreatedForDropDownData('scheduler'));
  }, [dispatch]);

  return (
    <div>
      <h2 className="search-title">Scheduler Job Search</h2>      
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={searchsessionNightJob ? searchsessionNightJob : initialValues}
        enableReinitialize
        validationSchema={validationSchema}
      >
        {(props) => {
          const {values, handleChange, handleReset, setFieldValue, handleBlur, errors, touched} =
            props;
          return (
            <div>
              <Form autoComplete="off" noValidate>
                <div>
                  <ErrorBoundaryForComponents>
                    <div className="form-row standard-field-textfields new-standard-textfields">
                      <div className="col-md-4 col-lg-2 form-group">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Job Name`}
                          label="Job Name"
                          className={`${classes.labelName}`}
                          name="code"
                          value={values?.code}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(touched.code && errors.code)}
                          fullWidth
                        />
                      </div>
                      {/* <div   className="col-md-4 col-lg-2 form-group">
                        <TextField
                          margin="dense"
                          variant="standard"
                          placeholder={`Enter Job Name`}
                          label="Job Name"
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          name="jobName"
                          value={values.jobName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div> */}
                      <div className=" col-md-4 col-lg-4 form-group">
                        <TextField
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Job Description`}
                          label="Job Description"
                          className={`${classes.labelName}`}
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div>
                      <div className=" col-md-4 col-lg-3 col-xl-2 form-group">
                        <GuiAutoComplete
                          {...props}
                          classes={{
                            option: classes.option,
                            popper: classes.popper,
                          }}
                          name="status"
                          id="status"
                          size="small"
                          value={values.status}
                          options={statuses.map((each) => each.key)}
                          required
                          onChange={(e, value) => {
                            // if (value) {
                            setFieldValue('status', value);
                            // }
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={`${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                label="Scheduled Status"
                                placeholder="Select Job Status"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off',
                                }}
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="clientCode"
                          id="clientCode"
                          size="small"
                          value={values.clientCode}
                          options={clientCodeDropdownData || []}
                          getOptionLabel={(option) => {
                            return option && option.clientName ? option.clientName : '';
                            // ? option.clientNumber === null
                            //   ? option.clientName
                            //   : option.clientNumber + " - " + option.clientName
                            // : "";
                          }}
                          onChange={(e, value) => {
                            setFieldValue('clientCode', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={`${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                label="Client Code"
                                placeholder="Select Client Code"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdFor"
                          id="createdFor"
                          size="small"
                          value={values.createdFor}
                          options={createdForData}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createForOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('createdFor', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={`${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                label="Created For"
                                placeholder="Select Created For"
                              />
                              <FormHelperText variant="outlined">
                                {touched.createdFor && errors.createdFor}
                              </FormHelperText>
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdBy"
                          id="createdBy"
                          size="small"
                          value={values.createdBy}
                          options={createdByData}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createdByOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('createdBy', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={`${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                label="Created By"
                                placeholder="Select Created By"
                              />
                            </div>
                          )}
                        />
                      </div>
                      {/* <div   className="col-md-4 col-lg-2 form-group">
                        <TextField
                          margin="dense"
                          variant="standard"
                          placeholder={`Enter CreatedFor`}
                          label="CreatedFor"
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          name="createdFor"
                          value={values?.createdFor}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div> */}
                      <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group start-enddate">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={`${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.createdDate}
                            name="createdDate"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="Date Created"
                            onChange={(val) => {
                              setFieldValue('createdDate', val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.createdDate}
                            error={Boolean(touched?.createdDate && errors?.createdDate)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-md-4 col-lg-3 col-xl-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            popper: classes.popper,
                            option: classes.option,
                          }}
                          name="isDraft"
                          id="isDraft"
                          size="small"
                          options={StatusOptions}
                          required
                          value={values.isDraft}
                          getOptionLabel={(option) => {
                            return option && option?.value;
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('isDraft', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={`${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                // InputLabelProps={{ shrink: true }}
                                label="Status"
                                placeholder="Select Status"
                              />
                            </div>
                          )}
                        />
                      </div>
                      {/* <div    className="col-md-4 col-lg-2 form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDateTimePicker
                            className={` ${classes.labelName}`}
                            format="MM/dd/yyyy hh:mm:ss"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.nextRunTime}
                            name="nextRunTime"
                            // minDate={}
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            helperText={null}
                            onBlur={handleBlur}
                            inputVariant="standard"
                            label="Next Run Time"
                            onChange={(val) => {
                              setFieldValue("nextRunTime", val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.nextRunTime}
                            error={Boolean(touched?.nextRunTime && errors?.nextRunTime)}
                          />

                        </MuiPickersUtilsProvider>
                        <FormHelperText
                          style={{ color: "red" }}
                          margin="dense"
                          variant="outlined"
                        >
                          {touched?.nextRunTime && errors && errors?.nextRunTime}
                        </FormHelperText>
                      </div>
                      <div    className="col-md-4 col-lg-2 form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDateTimePicker
                            className={` ${classes.labelName}`}
                            format="MM/dd/yyyy hh:mm:ss"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.lastRunTime}
                            name="lastRunTime"
                            // minDate={}

                            helperText={null}
                            onBlur={handleBlur}
                            inputVariant="standard"
                            label="Last Run Time"
                            onChange={(val) => {
                              setFieldValue("lastRunTime", val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.lastRunTime}
                            error={Boolean(touched?.lastRunTime && errors?.lastRunTime)}
                          />

                        </MuiPickersUtilsProvider>
                        <FormHelperText
                          style={{ color: "red" }}
                          margin="dense"
                          variant="outlined"
                        >
                          {touched?.lastRunTime && errors && errors?.lastRunTime}
                        </FormHelperText>
                      </div> */}
                      <div className="col-md-4 col-lg-3 form-group">
                        <div className="d-flex">
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn ${classes.buttonRoot}`}
                            onClick={() => {
                              handleReset();
                              setSearchData({});
                              setSubmit(true);
                              sessionStorage.removeItem('searchNightJob');
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="outlined"
                            type="submit"
                            className={`search-btn mx-1 ${classes.buttonRoot}`}
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </ErrorBoundaryForComponents>
                </div>
              </Form>
              {isLoading && <PageLoader />}
              {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
              {successMsg && <SuccessSnackbar successMsg={successMsg} />}
            </div>
          );
        }}
      </Formik>
      <NightJobSearchTable
        setTabValue={setTabValue}
        setValue={setValue}
        setJobCode={setJobCode}
        submit={submit}
        setSubmit={setSubmit}
        searchData={searchData}
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        searchFlag={searchFlag}
        setNightJobCode={setNightJobCode}
        setIsCopyRowData={setIsCopyRowData}
        setSelected={setSelected}
      />
    </div>
  );
};

export default NightJobSearch;
